module.exports = __webpack_public_path__ + "static/the-miracle-of-mindfulness-a643a70ce69a16aad8681b969a82115a.jpg";